import { iconDownload } from "@kensho/icons";
import { ButtonLink } from "@kensho/neo";

import { useObjectURL } from "../../../hooks/use-object-url";

export function DownloadMediaFileButton({
  mediaFile,
  name = "audio",
}: {
  mediaFile?: File;
  name?: string;
}) {
  const url = useObjectURL(mediaFile);

  return (
    <ButtonLink
      href={url || ""}
      download={name}
      aria-label="Download media"
      icon={iconDownload}
      minimal
      intent="primary"
      disabled={!mediaFile}
    >
      Download media
    </ButtonLink>
  );
}
